export const formatDate = (date: string) => {
  const options = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  };
  const formatDate = new Date(date);
  return formatDate.toLocaleString('ru', options);
};

export const formatDateTime = (date: string) => {
  const options = {
    timeZone: 'Europe/Moscow',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  const formatDate = new Date(date);
  return formatDate.toLocaleString('ru', options);
};
